import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class SaleDetailByItemService extends DatabaseGwService {
  URL_PATH: string ='/report-sale-detail';


}
